export const ADMIN_USER_ID = 1;
